import { createAction, props } from '@ngrx/store';
export const setBrandingClientGroup = createAction('[Custom PDF Report Modal] Set branding client group', props());
